import React from 'react';

/*
  Logo do João Vítor, extraída do PDF original dele (tools/logo_do_pdf.py).
  Entra como máscara CSS em vez de <img>: assim pega a cor do texto em volta
  (currentColor) e a mesma logo serve escura no papel e clara no fundo escuro.
*/
const VARIANTES = {
  horizontal: { src: '/img/logo/3-horizontal.svg', proporcao: '2230.6 / 307.8', nome: 'Morgana' },
  studio: { src: '/img/logo/4-horizontal-studio.svg', proporcao: '2580.1 / 651.5', nome: 'Morgana audiovisual studio' },
  simbolo: { src: '/img/logo/1-simbolo.svg', proporcao: '1462.3 / 1777', nome: 'Morgana' },
  empilhada: { src: '/img/logo/2-empilhada.svg', proporcao: '2170 / 866.2', nome: 'Morgana' },
};

const Logo = ({ variante = 'horizontal', className, style }) => {
  const v = VARIANTES[variante];
  const mascara = `url(${v.src}) center / contain no-repeat`;
  return (
    <span
      role="img"
      aria-label={v.nome}
      className={className}
      style={{
        display: 'inline-block',
        aspectRatio: v.proporcao,
        backgroundColor: 'currentColor',
        WebkitMask: mascara,
        mask: mascara,
        ...style,
      }}
    />
  );
};

export default Logo;
